import { submitIdpAnswers } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  SubmitIDPAnswersRequestT,
  DosespotIDPRecordT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';
import { logger } from '@/shared';

/**
 * Submit IDP verification answers for the authenticated user.
 */
export async function fetchSubmitIdpAnswers(
  data: SubmitIDPAnswersRequestT,
  signal?: AbortSignal
): Promise<DosespotIDPRecordT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await submitIdpAnswers(data, config);
  const result = lotusHealthZod.submitIdpAnswersResponse.parse(response.data) as DosespotIDPRecordT;

  logger.info('dosespot.idp.submitAnswers', {
    source: 'entities/dosespot-idp/api',
    currentState: result.current_state,
    answerCount: data.answers?.length ?? 0,
  });

  return result;
}
